import { DateTime } from "luxon";
import { parseIsoCached } from "@/lib/utils";

export function formatRelativeNoticeTimestamp(iso: string): string {
  const dt = parseIsoCached(iso);
  if (!dt.isValid) return "";

  const now = DateTime.now();
  const minutes = Math.floor(now.diff(dt).as("minutes"));
  if (minutes < 1) return "now";
  if (minutes < 60) return `${minutes}m`;

  const hours = Math.floor(now.diff(dt).as("hours"));
  if (hours < 24) return `${hours}h`;

  const days = Math.floor(now.diff(dt).as("days"));
  if (days < 30) return `${days}d`;

  const months = Math.floor(now.diff(dt).as("months"));
  if (months < 12) return `${months}mo`;

  return `${Math.floor(now.diff(dt).as("years"))}y`;
}
